import React from "react";
import { UserAuth } from "../../utils/AuthContext";
import "./Logout.css";
import LogoutIcon from '@mui/icons-material/Logout';

export default function Logout() {
  const { logout } = UserAuth();

  return (
    <button className="login_btn" onClick={logout}>
      <h1>Logout</h1><LogoutIcon/>
    </button>
  );
}
